import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { BaseControlComponent } from './base-control.component';
import { FormFieldComponent } from './form-field.component';
@Component({
  selector: 'app-textarea',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    FormFieldComponent,
    TextareaModule,
  ],
  template: `
    <app-form-field
      [control]="control"
      [id]="id"
      [label]="label"
      [helpText]="helpText"
      [showHelpText]="showHelpText"
      [errorId]="errorId"
      [placeholder]="placeholder"
      [screenReaderLabel]="screenReaderLabel"
    >
      <textarea
        pTextarea
        [formControl]="control"
        [id]="id"
        class="tw-w-full app-input-border"
        [class]="{
          'ng-invalid': touchedInvalid,
          'ng-dirty': touchedInvalid,
        }"
        [attr.aria-labelledby]="label || placeholder || screenReaderLabel ? id + '-label' : null"
        [attr.aria-describedby]="describedBy"
        [attr.required]="required ? true : null"
        [attr.aria-required]="required ? 'true' : null"
        rows="5"
        cols="30"
        [autoResize]="false"
        [rows]="rows"
      ></textarea>
    </app-form-field>
  `,
  styles: ``,
})
export class TextareaComponent extends BaseControlComponent {
  @Input()
  rows: string;

  /** Screen reader only label when no visible label is shown */
  @Input()
  screenReaderLabel: string;
}
